import gql from 'graphql-tag';

import { getSingleProp } from 'src/utils/lib/graphql';
import apolloClient from 'src/store/client';
import { BRIEF_DEBUG_DATA_VISIBLE } from 'src/lib/featureFlags';
import { VARIATION_FRAGMENT } from './schema';

const MUTATION = gql`
  mutation UpdateVariation(
    $id: ID!
    $assetType: String!
    $copyText: String
    $copyTextMarkup: JSON
    $forceScoring: Boolean
    $scoringMethod: ScoringMethodInput
  ) {
    updateVariation(
      id: $id
      assetType: $assetType
      copyText: $copyText
      copyTextMarkup: $copyTextMarkup
      forceScoring: $forceScoring
      scoringMethod: $scoringMethod
    ) {
      ...Variation
      language
    }
  }
  ${VARIATION_FRAGMENT}
`;

const prepareContext = (variationId, assetType) => {
  if (!BRIEF_DEBUG_DATA_VISIBLE) {
    return null;
  }

  const title = `"update variation" request [variationId: ${variationId}, assetType: ${assetType}]`;
  return { traceAuthorComplete: true, traceAuthorCompleteTitle: title };
};

export const updateVariation = (
  { id, assetType, copyText, copyTextMarkup, scoringMethod },
  options
) => {
  const mutateOptions = {
    mutation: MUTATION,
    variables: {
      id,
      assetType,
      copyText,
      copyTextMarkup,
      scoringMethod,
      forceScoring: true,
    },
    context: prepareContext(id, assetType),
  };

  if (options && options.abortSignal) {
    mutateOptions.context = {
      ...mutateOptions.context,
      fetchOptions: {
        signal: options.abortSignal,
      },
    };
  }

  return apolloClient.mutate(mutateOptions).then(({ data }) => getSingleProp(data));
};
